import { cn } from '@/lib/utils';

interface ArcDividerProps {
  className?: string;
  color?: 'primary' | 'muted' | 'success';
  flip?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'w-16 h-4',
  md: 'w-24 h-6',
  lg: 'w-32 h-8',
};

const colorClasses = {
  primary: 'text-primary',
  muted: 'text-muted-foreground/30',
  success: 'text-success',
};

export function ArcDivider({ 
  className, 
  color = 'primary', 
  flip = false,
  size = 'md' 
}: ArcDividerProps) {
  return (
    <svg
      className={cn(
        sizeClasses[size],
        colorClasses[color],
        flip && 'rotate-180',
        className
      )}
      viewBox="0 0 100 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M 5 25 Q 50 5 95 25"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}

// Export a hero version with animated appearance
export function ArcDividerAnimated({ className, ...props }: ArcDividerProps) {
  return (
    <svg
      className={cn('w-24 h-8', className)}
      viewBox="0 0 100 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M 5 25 Q 50 5 95 25"
        stroke="hsl(var(--primary))"
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="none"
        className="animate-[draw_1s_ease-out_forwards]"
        style={{
          strokeDasharray: 120,
          strokeDashoffset: 120,
        }}
      />
    </svg>
  );
}
